export const DEPLOY_MODEL_SUCCESS_MODEL_DEPLOYED = 'europa.project.model.DeployModel.ModelDeployed';
export const DEPLOY_MODEL_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.DeployModel.UnexpectedFailure';
export const GET_MODEL_TAG_CHECK_CANDIDATES_SUCCESS_MODEL_TAG_CHECK_CANDIDATES =
    'europa.project.model.GetModelTagCheckCandidates.ModelTagCheckCandidates';
export const GET_MODEL_TAG_CHECK_CANDIDATES_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.GetModelTagCheckCandidates.UnexpectedFailure';
export const GET_MODEL_TAG_OUTPUT_COLUMNS_SUCCESS_MODEL_TAG_OUTPUT_COLUMNS =
    'europa.project.model.GetModelTagOutputColumns.ModelTagOutputColumns';
export const GET_MODEL_TAG_OUTPUT_COLUMNS_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.GetModelTagOutputColumns.UnexpectedFailure';
export const GET_MODEL_TAG_SOURCE_TABLES_SUCCESS_MODEL_TAG_SOURCE_TABLES =
    'europa.project.model.GetModelTagSourceTables.ModelTagSourceTables';
export const GET_MODEL_TAG_SOURCE_TABLES_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.GetModelTagSourceTables.UnexpectedFailure';
export const LIST_MODEL_TAGS_SUCCESS_MODEL_TAGS = 'europa.project.model.ListModelTags.ModelTags';
export const LIST_MODEL_TAGS_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.ListModelTags.UnexpectedFailure';
export const LIST_MODELS_SUCCESS_MODELS = 'europa.project.model.ListModels.Models';
export const LIST_MODELS_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.ListModels.UnexpectedFailure';
export const REDEPLOY_MODEL_SUCCESS_MODEL_REDEPLOYED =
    'europa.project.model.RedeployModel.ModelRedeployed';
export const REDEPLOY_MODEL_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.RedeployModel.UnexpectedFailure';
export const RUN_FULL_MATERIALIZATION_SUCCESS_JOB_RUN_RESULT =
    'europa.project.model.RunFullMaterialization.JobRunResult';
export const RUN_FULL_MATERIALIZATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.RunFullMaterialization.UnexpectedFailure';
export const RUN_INCREMENTAL_MATERIALIZATION_SUCCESS_JOB_RUN_RESULT =
    'europa.project.model.RunIncrementalMaterialization.JobRunResult';
export const RUN_INCREMENTAL_MATERIALIZATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.RunIncrementalMaterialization.UnexpectedFailure';
export const SET_MODEL_SUCCESS_MODEL_UPDATED = 'europa.project.model.ModelUpdated';
export const SET_MODEL_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.UnexpectedFailure';
export const UPDATE_MODEL_JOBS_SUCCESS_SUCCEEDED = 'europa.project.model.UpdateModelJobs.Succeeded';
export const UPDATE_MODEL_JOBS_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.UpdateModelJobs.UnexpectedFailure';
export const VALIDATE_MODEL_JOBS_SUCCESS_MODEL_JOBS_VALIDATION_RESULT =
    'europa.project.model.ValidateModelJobs.ModelJobsValidationResult';
export const VALIDATE_MODEL_JOBS_FAILURE_UNEXPECTED_FAILURE =
    'europa.project.model.ValidateModelJobs.UnexpectedFailure';
export const MODEL_REFERENCES_UPDATED = 'europa.project.model.ModelReferencesUpdated';